import { Zap } from "lucide-react";

export function Brand({ size = "md", withText = true }) {
  const dim = size === "sm" ? "w-7 h-7" : size === "lg" ? "w-10 h-10" : "w-8 h-8";
  const text = size === "lg" ? "text-2xl" : "text-lg";
  return (
    <div className="flex items-center gap-2.5 select-none">
      <div className={`${dim} rounded-lg bg-primary/10 border border-primary/30 grid place-items-center`}>
        <Zap className="w-1/2 h-1/2 text-primary" strokeWidth={2.5} />
      </div>
      {withText && (
        <span className={`${text} font-display font-bold tracking-tight text-slate-50`}>
          LeadForge<span className="text-primary"> AI</span>
        </span>
      )}
    </div>
  );
}

export function ModeBadge({ mode, className = "", testid = "mode-badge" }) {
  const live = mode === "live";
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 text-[10px] font-mono font-semibold uppercase tracking-wider px-2 py-0.5 rounded-md border ${live ? "bg-emerald-500/10 text-emerald-400 border-emerald-500/25" : "bg-amber-500/10 text-amber-400 border-amber-500/25"} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full lf-live-dot ${live ? "bg-emerald-400" : "bg-amber-400"}`} />
      {live ? "Live Data" : "Demo Data"}
    </span>
  );
}

export function DemoBadge({ className = "" }) {
  return (
    <span
      data-testid="demo-badge"
      className={`inline-flex items-center gap-1.5 text-[10px] font-mono font-semibold uppercase tracking-wider px-2 py-0.5 rounded-md bg-amber-500/10 text-amber-400 border border-amber-500/25 ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-amber-400 lf-live-dot" />
      Demo Data
    </span>
  );
}
